import React from 'react';
import {observer} from 'mobx-react';
import {Overview} from './overview';
import {Questions} from './questions';
import {Participants} from './participants';
import {Review} from './review';

class Step extends React.Component {
  render() {
    const {step, uiState} = this.props;

    switch (step) {
      case 'overview':
        return <Overview uiState={uiState}/>;
      case 'questions':
        return <Questions uiState={uiState}/>;
      case 'participants':
        return <Participants uiState={uiState}/>;
      case 'review':
        return <Review uiState={uiState}/>;
      default:
        throw new Error(`Location ${step} is not supported.`);
    }
  }
}

export default observer(Step);
